import { h, Component } from 'preact';
import { route } from 'preact-router';
import TicketLogic from '../utils/ticket-logic.jsx';

import AwrabetRecallBet from '../../awrabet/mobile-pages/recall-bet.jsx';

export default class RecallBet extends AwrabetRecallBet {
    render() {
        return null; // This component does not render anything
    }
}